export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";